import { IconPresentation, IconShare } from '@assets'
import { ROUTES } from '@constants'
import { Link, useLocation } from 'react-router-dom'

import { Label } from '../Label/Label'
import { Style } from './style'

const TabbedLayout = () => {
  const location = useLocation()

  const Tab = ({ to, children, tabStyle = '' }) => (
    <Link to={to} className={`${tabStyle} ${location.pathname === to ? 'active' : ''}`}>
      {children}
    </Link>
  )

  return (
    <Style>
      <div className='container'>
        <Tab to={ROUTES.PLANT_LIST} tabStyle='tab-link'>
          <Label
            image={IconPresentation}
            text={'Plant Managements'}
            containerLabel={'container-label'}
            imageLabel={'image-label'}
            textLabel={'text-label'}
          />
        </Tab>
        <Tab to={ROUTES.ADMIN_DASHBOARD.LIST} tabStyle='tab-link'>
          <Label
            image={IconShare}
            text={'Summary Managements'}
            containerLabel={'container-label'}
            imageLabel={'image-label'}
            textLabel={'text-label'}
          />
        </Tab>
      </div>
    </Style>
  )
}

export default TabbedLayout
